export default __webpack_public_path__ + "static/new8-04-4b5b72fef8180cf56ab2ad99255f67c5.jpg";